import React, { useMemo } from "react";
import Select from "react-select";
import { buildBorrowerSelectOptions, excludeBorrowersFromSelect } from "./borrowerSelectUtils";

const MODAL_MENU_STYLES = {
  menuPortal: (base) => ({ ...base, zIndex: 1080 }),
};

const BorrowerSelect = ({
  borrowers = [],
  excludeIds = [],
  value,
  onChange,
  inputId = "borrower-select",
  placeholder = "Search borrower by name or phone…",
  isDisabled = false,
  isClearable = true,
  noOptionsMessage = "No borrowers found",
  menuPortalTarget = typeof document !== "undefined" ? document.body : undefined,
}) => {
  const options = useMemo(() => {
    const eligible = excludeBorrowersFromSelect(borrowers, excludeIds);
    return buildBorrowerSelectOptions(eligible);
  }, [borrowers, excludeIds]);
  const selectedOption = options.find((option) => String(option.value) === String(value ?? "")) || null;

  return (
    <Select
      inputId={inputId}
      classNamePrefix="credora-select"
      options={options}
      value={selectedOption}
      onChange={(option) => onChange?.(option ? String(option.value) : "")}
      placeholder={placeholder}
      isClearable={isClearable}
      isSearchable
      isDisabled={isDisabled}
      noOptionsMessage={() => noOptionsMessage}
      menuPortalTarget={menuPortalTarget}
      styles={MODAL_MENU_STYLES}
    />
  );
};

export default BorrowerSelect;
